export default __webpack_public_path__ + "static/media/Mark-2-HUD-04.19864092.jpg";